import React from 'react';

import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { G8Manager } from './G8Manager';

const G8Page: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="g8-page-content text-center">
      <Helmet>
        <title>{t('G8.TITLE')}</title>
        <body className="g8-page" />
      </Helmet>
      <Row>
        <Col md={{ size: 6, offset: 3 }}>
          <div className="card mt-5 align-items-center">
            <img className="g8-logo" alt="Logo" src={require('./assets/images/Logos.png')} loading="lazy" />
            <div className="card-body">
              <G8Manager />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(G8Page);
